const Side = {
	Top:0, Right:1, Bottom:2, Left:3
};
Side.getCssClass = function(side){
	switch(side){
		case Side.Top: return 'top';
		case Side.Right: return 'right';
		case Side.Bottom: return 'bottom';
		case Side.Left: return 'left';
		default:
			throw new Error('Not Implemented');
	}
	
}
export default Side;